// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1790692376024
      var cssReload = require("/home/vsts/work/1/s/src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  